import React from 'react';
import { Alert, Button, Space, Typography } from 'antd';
import { CheckCircleOutlined } from '@ant-design/icons';
import { formatQuotationPrintIdentity } from '@/utils/quotationRevisionPolicy';
import type { Quotation } from '@/services/quotation.service';
import dayjs from 'dayjs';

const { Text, Title } = Typography;

type Props = {
  quotation: Quotation;
  onProceedToContractReview?: () => void;
  onConvertToSalesOrder?: () => void;
  isTradingRental?: boolean;
  canProceed?: boolean;
};

export const QuotationAcceptanceBanner: React.FC<Props> = ({
  quotation,
  onProceedToContractReview,
  onConvertToSalesOrder,
  isTradingRental,
  canProceed,
}) => {
  if (quotation.status !== 'Accepted' || !quotation.is_current_submitted) return null;

  return (
    <Alert
      type="success"
      showIcon
      icon={<CheckCircleOutlined />}
      style={{ marginBottom: 16 }}
      message={
        <Space direction="vertical" size={4}>
          <Title level={5} style={{ margin: 0, color: '#389e0d' }}>
            CUSTOMER ACCEPTED
          </Title>
          <Text strong>
            {formatQuotationPrintIdentity(quotation.quotation_number, quotation.revision_number)}
          </Text>
          {quotation.acceptance_date ? (
            <Text type="secondary">
              Accepted on {dayjs(quotation.acceptance_date).format('DD MMM YYYY')}
            </Text>
          ) : null}
        </Space>
      }
      action={
        canProceed ? (
          isTradingRental ? (
            <Button type="primary" onClick={onConvertToSalesOrder}>
              Convert to Customer Order
            </Button>
          ) : (
            <Button type="primary" onClick={onProceedToContractReview}>
              Proceed to Contract Review
            </Button>
          )
        ) : undefined
      }
    />
  );
};

export default QuotationAcceptanceBanner;
